import { useQuery } from "@tanstack/react-query";
import {
  CsobDataSetDataDto,
  UserProfileDto,
  UserRole,
} from "@green0meter/api-client";

import { DOMAIN_CSOB } from "../domain";

import { csobHubApi } from "@api/services";
import { TANSTACK_QUERY_STALE_TIME } from "@constants";
import { roleGuard } from "@api";

export const ACTION_GET_CSOB_DATASET_COMPARISON = "GET_CSOB_DATASET_COMPARISON";

const allowedRoles = [UserRole.Owner];

const getGetCsobDatasetComparison = async (): Promise<CsobDataSetDataDto> => {
  const response = await csobHubApi.csobHubControllerGetCsobDatasetComparison();

  return response.data;
};

export const useGetCsobDatasetComparison = (
  user: UserProfileDto | null,
  enable: boolean = false,
): {
  csobDatasetComparison?: CsobDataSetDataDto;
  csobDatasetComparisonEnabled: boolean;
  errorGetCsobDatasetComparison: Error | null;
  isPendingGetCsobDatasetComparison: boolean;
  isLoadingGetCsobDatasetComparison: boolean;
  isFetchingGetCsobDatasetComparison: boolean;
  refetchCsobDatasetComparison: () => void;
} => {
  const enabled = enable && roleGuard(user, allowedRoles);
  const { data, error, isPending, isLoading, isFetching, refetch } = useQuery({
    queryKey: [DOMAIN_CSOB, ACTION_GET_CSOB_DATASET_COMPARISON],
    queryFn: () => getGetCsobDatasetComparison(),
    staleTime: TANSTACK_QUERY_STALE_TIME,
    enabled,
  });

  return {
    csobDatasetComparison: data,
    csobDatasetComparisonEnabled: enabled,
    errorGetCsobDatasetComparison: error,
    isPendingGetCsobDatasetComparison: isPending,
    isLoadingGetCsobDatasetComparison: isLoading,
    isFetchingGetCsobDatasetComparison: isFetching,
    refetchCsobDatasetComparison: refetch,
  };
};
